import { createContext } from 'react';
import { UserGetAppData } from '../../../../@api-client';

export interface UserContextType {
  user: UserGetAppData;
}

export const UserContext = createContext<UserContextType | undefined>(undefined);
